import { config } from '../../config/config';
import { client } from '../client';

export interface UserValidationPayload {
  org: string;
  email?: string;
  phone_number?: string;
}

interface UserValidationResponse {
  success: boolean;
}

export const userValidation = async (payload: UserValidationPayload): Promise<boolean> => {
  // Route through the shared client so the request interceptor attaches the GA
  // attribution headers (this signup/auth validation call is attribution-relevant).
  const { data } = await client.post<UserValidationResponse>('/users/validate', payload, {
    headers: {
      'x-organization-id': config.organization_id,
    },
  });

  return data.success;
};
